import { render } from "./CreateMasterBoardModal.vue?vue&type=template&id=530e583a&scoped=true"
import script from "./CreateMasterBoardModal.vue?vue&type=script&lang=js"
export * from "./CreateMasterBoardModal.vue?vue&type=script&lang=js"

import "./CreateMasterBoardModal.vue?vue&type=style&index=0&id=530e583a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-530e583a"

export default script